// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const AddressLogs = t.struct({
    addressType: t.String,
    city: t.String,
    component17: t.String,
    component18: t.String,
    countryCode: t.String,
    modifiedBy: t.String,
    remark: t.String,
    state: t.String,
    street1: t.String,
    street2: t.String,
    timeStamp: t.String,
    zipCode: t.String
}, {
    defaultProps: {
        addressType: '',
        city: '',
        component17: '',
        component18: '',
        countryCode: '',
        modifiedBy: '',
        remark: '',
        state: '',
        street1: '',
        street2: '',
        timeStamp: '',
        zipCode: ''
    },
    name: 'AddressLogs',
    strict: true
});
